import classNames from 'classnames';
import React from 'react';

import StudentHomepageSidebarContent from './StudentHomepageSidebarContent';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props {
  pathname: string;
}

export default function StudentHomepageSidebarDesktop({pathname}: Props) {
  const {isSidebarExpanded} = useStudentDashboard();

  return (
    <div
      className={classNames(
        'col-start-1 row-span-3 row-start-2 h-full transition-[width] duration-200',
        {
          'w-[310px]': isSidebarExpanded,
          'w-x0': !isSidebarExpanded
        }
      )}
    >
      <div
        className={classNames(
          'relative! z-10 flex h-full w-[310px] flex-col gap-x3 px-x4 py-x3 transition-[left] duration-200',
          {'left-[0]': isSidebarExpanded},
          {'-left-[310px]': !isSidebarExpanded}
        )}
      >
        <StudentHomepageSidebarContent pathname={pathname} />
      </div>
    </div>
  );
}
